import React, { useEffect, useState } from "react";
import Navbar from "../navbar/navbar";
import { formatDate, formatISODate, getBase64ImageFromUrl, getSevaCollectionExcelReport, getSevaCollectionReportList } from "../../services/receipt.service";
import Swal from "sweetalert2";
import Datatable from "../../datatable/Datatable";
import DatePicker from "react-datepicker";
import headerLogo from "../../assets/images/DailyPoojaReport.png"
import { DailySevaCollectionPrint } from "../../print/dailySevaCollectionPrint";
import "./reportModule.css";
import { ReportExportActions, ReportListHeading, ReportListLoading } from "./ReportListUi";


const DailySevaCollectionComponent = () => {

    const [sevaCollectionMap, setSevaCollectionMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('CA');
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        fetchSevaReportList(selectedDate);
    }, [selectedDate]);

    const fetchSevaReportList = async (date) => {
        setLoading(true);
        try {
            const formateddate = formatISODate(date);
            const response = await getSevaCollectionReportList(formateddate);
            if (response) {
                setSevaCollectionMap(response);
            } else {
                Swal.fire("Error", "Failed to fetch seva collection report list", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "SN", selector: (row) => row.sn, sortable: true, align: 'text-center' },
        { name: "Receipt No", selector: (row) => row.receiptNo, sortable: true, align: 'text-start' },
        { name: "Receipt Date", selector: (row) => row.receiptDate, sortable: true, align: 'text-start' },
        { name: "Name of Devotee", selector: (row) => row.devoteeName, sortable: true, align: 'text-start' },
        { name: "Mobile", selector: (row) => row.mobile, sortable: true, align: 'text-start' },
        { name: "Seva Name", selector: (row) => row.poojaName, sortable: true, align: 'text-start' },
        { name: "Seva Date", selector: (row) => row.poojaDateTime1, sortable: true, align: 'text-start' },
        { name: "Seva Amount", selector: (row) => row.poojaAmt1, sortable: true, align: 'text-start' },
    ];

    const mappedData = (type) => {
        const list = sevaCollectionMap[type] || [];
        return list.map((item, index) => ({
            sn: index + 1,
            receiptNo: item.receiptNo || '-',
            receiptDate: formatDate(item.receiptDate) || '-',
            devoteeName: item.devoteeName || '-',
            mobile: item.mobile || '-',
            poojaName: item.poojaName || '-',
            poojaDateTime1: formatDate(item.poojaDateTime1) || '-',
            poojaAmt1: item.poojaAmt1 || 0,
        }));
    };

    const getTotal = (type) => {
        return (sevaCollectionMap[type] || []).reduce((sum, item) => sum + (item.poojaAmt1 || 0), 0);
    };

    const getGrandTotal = () => {
        return Object.values(sevaCollectionMap).flat().reduce((sum, item) => sum + (item.poojaAmt1 || 0), 0);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setActiveTab('CA');
    };

    const handlePrint = async () => {
        const base64Logo = await getBase64ImageFromUrl(headerLogo);
        await DailySevaCollectionPrint(selectedDate, base64Logo, sevaCollectionMap);
    };

    const handleDownload = async () => {
        const fromDate = formatISODate(selectedDate);
        const response = await getSevaCollectionExcelReport(fromDate);
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sevaCollectionReport.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="card report-list-page">
            <Navbar />
            <ReportListHeading title="Daily Seva Collection" />
            <div className="report-list-toolbar rowHeadercolor">
                <div className="report-list-filters col-md-8 d-flex">
                    <div className="d-flex align-items-center me-4">
                        <label className="fw-bold me-2 text-nowrap">
                            Select Date:
                        </label>
                        <DatePicker
                            className="form-control"
                            selected={selectedDate}
                            // onChange={(date) => setSelectedDate(date)}
                            onChange={handleDateChange}
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                        />
                    </div>
                </div>

                <div className="report-list-total col-md-4 text-end fw-bold">
                    Grand Total: ₹ {getGrandTotal().toFixed(2)}
                </div>
                <ReportExportActions onPrint={handlePrint} onDownload={handleDownload} disabled={loading} />
            </div>

            <div className="report-list-tabs">
                <div className="report-list-tabs__items">
                    {["CA", "CQ", "DC", "RT", "UP", "NB", "WL", "Online"].map((type) => {
                        const list = sevaCollectionMap[type] || [];
                        return (
                            <button
                                key={type}
                                className={`btn ${activeTab === type ? 'btn-primary' : 'btn-outline-primary'}`}
                                onClick={() => setActiveTab(type)}
                            >
                                {type === 'CA' && 'Cash'}
                                {type === 'CQ' && 'Cheque'}
                                {type === 'DC' && 'Card'}
                                {type === 'RT' && 'RTGS'}
                                {type === 'UP' && 'UPI'}
                                {type === 'NB' && 'NetBank'}
                                {type === 'WL' && 'Wallet'}
                                {type === 'Online' && 'Online'}
                                <span className="badge bg-warning text-dark ms-2">{list.length}</span>
                            </button>
                        );
                    })}
                </div>
            </div>


            <div id="card-body customized-card" className="report-list-table">
                <h5 className="report-list-subheading">
                    {activeTab === 'CA' && 'Cash'}
                    {activeTab === 'CQ' && 'Cheque'}
                    {activeTab === 'DC' && 'Card'}
                    {activeTab === 'RT' && 'RTGS'}
                    {activeTab === 'UP' && 'UPI'}
                    {activeTab === 'NB' && 'NetBank'}
                    {activeTab === 'WL' && 'Wallet'}
                    {activeTab === 'Online' && 'Online'} Collection Report
                </h5>
                {loading ? <ReportListLoading message="Loading collection details..." /> : <Datatable columns={columns} data={mappedData(activeTab)} />}
            </div>
            <div className="report-list-summary">
                <h6 className="fw-bold">Total
                    {activeTab === 'CA' && ' Cash'}
                    {activeTab === 'CQ' && ' Cheque'}
                    {activeTab === 'DC' && ' Card'}
                    {activeTab === 'RT' && ' RTGS'}
                    {activeTab === 'UP' && ' UPI'}
                    {activeTab === 'NB' && ' NetBank'}
                    {activeTab === 'WL' && ' Wallet'}
                    {activeTab === 'Online' && ' Online'} Amount: ₹ {getTotal(activeTab).toFixed(2)}</h6>
            </div>
        </div>
    );
}

export default DailySevaCollectionComponent;